import { useDeviceType } from "@hook/useDeviceType";
import { useGetAvailableAppointmentDateList } from "@modules/eirCustomersFacade/swr";

interface IParams {
    appointmentId: number;
    isModalOpen: boolean;
}

export const useAppointmentReschedule = (props: IParams) => {
    const { appointmentId, isModalOpen } = props;

    const { data, error } = useGetAvailableAppointmentDateList(appointmentId, isModalOpen);

    const isLoading = isModalOpen && !data && !error;

    const { isMobile } = useDeviceType();

    return { availableDateList: data, isAvailableDateListLoading: isLoading, availableDateListError: error, isMobile };
};
